var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 72,
    viewBox: "0 0 115 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_37)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 51.7031L7.38095 33.499H14.4729L7.10136 51.7031H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0782 51.7031L98.3647 33.499H102.231L94.9451 51.7031H91.0782Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_37",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 33,
    width: 10,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.747 51.7031V33.499H105.408V51.7031H114.747Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_37)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.408 51.7031L112.693 33.499H114.747L107.461 51.7031H105.408Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5713 0C73.5178 0.000255504 89.6875 16.1146 89.6875 35.9902C89.6875 55.8638 73.5178 71.9753 53.5713 71.9756C33.6318 71.9756 17.4639 55.8639 17.4639 35.9902C17.4639 16.1144 33.6318 0 53.5713 0ZM26.1631 33.499C26.1631 33.499 25.7218 33.4993 25.5615 33.8887L23.2285 39.6533C23.2266 39.6581 22.9975 40.2292 23.5273 40.2295H25.7227V51.2148C25.7229 51.4873 25.9381 51.7031 26.2129 51.7031H31.8721C32.1387 51.7031 32.3611 51.4873 32.3613 51.2148V40.2295H34.5674C35.8329 40.2295 36.1013 40.2644 36.5938 40.4932C36.8903 40.6048 37.157 40.8306 37.3027 41.0908C37.6011 41.6506 37.6758 42.3227 37.6758 44.3047V51.2148C37.676 51.4872 37.8959 51.7029 38.167 51.7031H43.5918C43.6016 51.7031 44.2068 51.698 44.4473 51.0996L45.6494 48.1387C47.2479 50.3698 49.8788 51.7031 53.1484 51.7031H53.8623C53.8623 51.7031 54.4795 51.7029 54.7236 51.0996L56.8174 45.9326V51.2148C56.8176 51.4873 57.0415 51.7031 57.3086 51.7031H62.8457C62.8608 51.703 63.4599 51.6952 63.7021 51.0996C63.7228 51.0486 65.9163 45.6202 65.9248 45.5791H65.9277C66.0116 45.1292 65.45 45.1231 65.4355 45.123H63.459V35.7217L69.6768 51.0996C69.9196 51.7029 70.5322 51.7031 70.5322 51.7031H77.0732C77.0732 51.7031 77.6888 51.7029 77.9316 51.0996L84.8252 34.0889C85.0637 33.4992 84.373 33.499 84.373 33.499H77.9541C77.9541 33.499 77.5119 33.4993 77.3555 33.8887L73.8027 44.7266L70.2529 33.8887C70.0969 33.5002 69.6536 33.499 69.6514 33.499H57.3086C57.0414 33.499 56.8174 33.7218 56.8174 33.9863V37.667C56.8174 34.7474 53.6995 33.499 51.874 33.499C47.7863 33.4991 45.0503 36.1825 44.1982 40.2617C44.1521 37.5556 43.9258 36.5858 43.1943 35.5928C42.8583 35.1062 42.3726 34.6967 41.8438 34.3584C40.755 33.7229 39.7768 33.499 37.6758 33.499H35.209C35.2018 33.4991 34.7615 33.5025 34.6055 33.8887L32.3613 39.4326V33.9863C32.3613 33.7218 32.1388 33.4991 31.8721 33.499H26.1631ZM54.1377 39.7754C55.6143 39.7754 56.8174 40.9776 56.8174 42.4521V45.123H53.0977C51.6174 45.123 50.4133 43.929 50.4131 42.4521C50.4131 40.9777 51.6172 39.7755 53.0977 39.7754H54.1377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav);
export default __webpack_public_path__ + "static/media/nav.0d0d0f68440d8fb708f666a7a187fa92.svg";
export { ForwardRef as ReactComponent };